// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React, {FC, useEffect} from "react";
// Router:
import { Route, Routes, useNavigate, useLocation } from "react-router-dom";
// Pages:
import { HomePage, LoginPage, NotFoundPage, PageConstructor } from "../pages";
// Redux-hooks:
import { useAppSelector } from "./redux-hooks.ts";
// Reducers:
import { getUser, getConfig } from "./reducer.ts"; // getDesktopType

const { rz, $ } = window;

const ClientRoutes:FC = () => {
  // const dispatch = useAppDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const user = useAppSelector(getUser);
  const cfg = useAppSelector(getConfig);
  // const isMobile = useAppSelector(getDesktopType);
  // const i1 = rz.arrFindObj(cfg.personalsettings, {key: "showdesktop"}); let persSettingsDesktop = false; if (~i1) persSettingsDesktop = cfg.personalsettings[i1].value;

  useEffect(() => {
    const qs = rz.urlQueryObject();
    // console.log({user, location_pathname: location.pathname, qs});
    if (location && location.pathname && location.pathname.startsWith("/data/")) {
      // Nothing to do
    }
    else if (!user.login && location.pathname !== "/app/login") {
      const encodedUri = encodeURIComponent(location.pathname + (location.search || ""));
      navigate("/app/login" + (!rz.arrContains(["/", "/app"], location.pathname) ? "?url=" + encodedUri : ""), {replace: true});
    }
    else if ((user && user.login) && location.pathname === "/app/login") {
      if (qs.url) {
        let decodedUri = decodeURIComponent(qs.url);
        if (decodedUri.startsWith(window.location.protocol + "//" + window.location.host)) { decodedUri = decodedUri.replace(window.location.protocol + "//" + window.location.host, "") }
        if ((/^:\d+/ig).test(decodedUri)) { decodedUri = decodedUri.replace((/^:\d+/ig), "") }
        if (cfg.isDev) { console.log("Redirect to URI: " + decodedUri) }
        navigate(decodedUri, {replace: true});
        // window.location.href = decodedUri;
      }
      else { navigate("/app", {replace: true}) }
    }
    else if ((user && user.login) && location.pathname === "/") {
      if (qs.url) {
        let decodedUri = decodeURIComponent(qs.url);
        if (decodedUri.startsWith(window.location.protocol + "//" + window.location.host)) { decodedUri = decodedUri.replace(window.location.protocol + "//" + window.location.host, "") }
        if ((/^:\d+/ig).test(decodedUri)) { decodedUri = decodedUri.replace((/^:\d+/ig), "") }
        if (cfg.isDev) { console.log("Redirect to URI: " + decodedUri) }
        navigate(decodedUri, {replace: true});
        // window.location.href = decodedUri;
      }
      else { navigate("/app", {replace: true}) }
    }
    // Special pages which must be reloaded full
    else if ((user && user.login) && location.pathname === "/app/pw/waybills") {
      const isYandexMapsLoaded = $("div#yaMapsWasLoadedSuccess");
      // Reload page force to load yandex-maps main script
      // eslint-disable-next-line no-self-assign
      if (!isYandexMapsLoaded || !isYandexMapsLoaded[0]) { window.location.href = window.location.href } // window.location.pathname = "/app/pw/waybills"
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, user.login]);

  return (
    <Routes>
      <Route path="/app" element={<HomePage />} />
      <Route path="/app/login" element={<LoginPage />} />
      <Route path="/app/notfound" element={<NotFoundPage />} />
      <Route path="/app/:section1" element={<PageConstructor />} />
      <Route path="/app/:section1/:section2" element={<PageConstructor />} />
      <Route path="/app/:section1/:section2/:section3" element={<PageConstructor />} />
      <Route path="/app/:section1/:section2/:section3/:section4" element={<PageConstructor />} />
      <Route path="/app/:section1/:section2/:section3/:section4/:section5" element={<PageConstructor />} />
    </Routes>
  )
};

export default ClientRoutes;
